import { useCallback, useContext } from 'react';
import { Sizes } from 'models/sizes';
import { TenantConfigContext } from 'context/TenantConfigContext';
import { api } from 'config/api';
import { useAuthenticatedApiCall } from './api.service';

const baseConfig = {
  baseURL: api.API_URL,
};

export const useSizeDataService = () => {
  const { makeAuthenticatedApiCall } = useAuthenticatedApiCall(baseConfig);
  const { accountNumber } = useContext(TenantConfigContext);

  const fetchSizeDataResponse = useCallback(
    async (search: string) => {
      const { data, error } = await makeAuthenticatedApiCall<Sizes>({
        url: 'sizes',
        method: 'GET',
        params: {
          search,
        },
      });
      return { data, error };
    },
    [makeAuthenticatedApiCall, accountNumber]
  );

  return {
    fetchSizeDataResponse,
  };
};
